import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStoryline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 9H7V7H21V9ZM21 13H7V11H21V13ZM21 17H7V15H21V17ZM5 17H3V15H5V17ZM5 7V9H3V7H5ZM5 13H3V11H5V13Z",
		fill: "currentColor"
	})
});
export default SvgStoryline;
